import React from 'react';

import { Button } from 'components/actions/Button';
import { ButtonColorsEnum } from 'constants/button-colors';
import { IconsEnum } from 'constants/icons';

export type ThirdNavRightControlsViewProps = {
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

export const ThirdNavRightControlsView = ({ onClick }: ThirdNavRightControlsViewProps): JSX.Element => (
  <>
    <div className={'hide-for-small-only'}>
      <Button
        type={'button'}
        variant={'solid'}
        size={'medium'}
        color={ButtonColorsEnum.primary}
        icon={{ side: 'left', value: IconsEnum.plus }}
        action={onClick}>
        <span className={'hide-for-small-only'}>Create a Snippet</span>
      </Button>
    </div>
    <div className={'show-for-small-only'}>
      <Button
        type={'button'}
        variant={'solid'}
        size={'medium'}
        color={ButtonColorsEnum.primary}
        icon={{ side: 'center', value: IconsEnum.plus }}
        action={onClick}
      />
    </div>
  </>
);
